let $measure: HTMLDivElement;

export function measureText(text: string, classes: string): number {
  if (!$measure) {
    $measure = document.createElement("div");
    $measure.id = "measureText";
    // note: without top:0 this is placed at the bottom and creates a white bar
    $measure.style = `position: absolute; visibility: hidden; width: auto; height: auto; white-space: nowrap; top: 0; left:0`;
    document.body.append($measure);
  }
  $measure.className = classes;
  $measure.textContent = text;
  return Math.ceil($measure.getBoundingClientRect().width);
}

// firefox 20ms per 1000
// chrome   1ms per 1000
// console.time("measureText");
// for (let i = 0; i < 1000; i++) {
//   measureText("hello, world!", "text-b-lemon inline-block text-base font-black");
// }
// console.timeEnd("measureText");
